module.exports = __webpack_public_path__ + "static/snow-report-panel-b62c65e8e5b8764adc6f4da5a35f2bc8.jpg";